module.exports = __webpack_public_path__ + "media/images/lp/industries/solution-01-740fdab2b417414cd65113abeb50e537.png";